export default __webpack_public_path__ + "static/media/dependants.11d30065.svg";